<script setup lang="ts">
import { ref, computed } from 'vue'
import SectionHeader from '../../common/SectionHeader.vue'

interface Props {
  stateVariations?: Record<string, string>
}

const props = defineProps<Props>()

const selectedState = ref('us')
const stateOptions = [
  { value: 'us', label: 'United States (General)' },
  { value: 'ca', label: 'California' },
  { value: 'tx', label: 'Texas' },
  { value: 'fl', label: 'Florida' },
  { value: 'ny', label: 'New York' },
  { value: 'co', label: 'Colorado' }
]

const currentStateInfo = computed(() => {
  if (!props.stateVariations) return 'Information not available for this location.'

  const stateKey = selectedState.value === 'us'
    ? 'General US'
    : stateOptions.find(s => s.value === selectedState.value)?.label || 'General US'

  return props.stateVariations[stateKey] || 'Information not available for this location.'
})

const selectedStateLabel = computed(() => {
  return stateOptions.find(s => s.value === selectedState.value)?.label || 'United States'
})
</script>

<template>
  <section class="bg-slate-50 rounded-2xl p-6 mb-8">
    <SectionHeader
      title="State & Location Variations"
      class="mb-4"
    />
    <p class="text-slate-700 max-w-3xl mb-4">
      Marijuana legality and workplace testing rules differ by state. Use the selector to view guidance tailored to your location.
    </p>
    <div class="mb-4">
      <label for="state-selector" class="sr-only">Select your state</label>
      <select
        id="state-selector"
        v-model="selectedState"
        class="rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm"
      >
        <option
          v-for="option in stateOptions"
          :key="option.value"
          :value="option.value"
        >
          {{ option.label }}
        </option>
      </select>
    </div>
    <div class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <p><strong>{{ selectedStateLabel }}:</strong> {{ currentStateInfo }}</p>
    </div>
  </section>
</template>
